import type {
  CommissionWithRelations,
  CreateCommissionInput,
  UpdateCommissionInput,
  IncomeReport,
} from '@peles/shared';
import { apiClient } from './client';

export async function getCommissions(filters?: {
  vendorId?: string;
  eventId?: string;
  startDate?: string;
  endDate?: string;
}): Promise<CommissionWithRelations[]> {
  const params: Record<string, string> = {};
  if (filters?.vendorId) params.vendorId = filters.vendorId;
  if (filters?.eventId) params.eventId = filters.eventId;
  if (filters?.startDate) params.startDate = filters.startDate;
  if (filters?.endDate) params.endDate = filters.endDate;
  const { data } = await apiClient.get<CommissionWithRelations[]>('/commissions', { params });
  return data;
}

export async function getCommission(id: string): Promise<CommissionWithRelations> {
  const { data } = await apiClient.get<CommissionWithRelations>(`/commissions/${id}`);
  return data;
}

export async function createCommission(
  input: CreateCommissionInput,
): Promise<CommissionWithRelations> {
  const { data } = await apiClient.post<CommissionWithRelations>('/commissions', input);
  return data;
}

export async function updateCommission(
  id: string,
  updates: UpdateCommissionInput,
): Promise<CommissionWithRelations> {
  const { data } = await apiClient.patch<CommissionWithRelations>(`/commissions/${id}`, updates);
  return data;
}

export async function deleteCommission(id: string): Promise<void> {
  await apiClient.delete(`/commissions/${id}`);
}

export async function getIncomeReport(filters?: {
  startDate?: string;
  endDate?: string;
}): Promise<IncomeReport> {
  const params: Record<string, string> = {};
  if (filters?.startDate) params.startDate = filters.startDate;
  if (filters?.endDate) params.endDate = filters.endDate;
  const { data } = await apiClient.get<IncomeReport>('/reports/income', { params });
  return data;
}
